import $ from 'jquery';
window.$ = window.jQuery = $;
import Cookie from './Cookie';
import Swiper from 'swiper';

let cookie = new Cookie(true);
cookie.init();

$('.wpcf7-list-item-label a').click(function (e) {
    e.preventDefault();
});


var galleryId = 1;
$('.wp-block-gallery').each(function(i, s){
    var $this = $(this);
    $this.attr('id', galleryId++);
    var figcaption = $this.find('figcaption');
    if (figcaption.length > 0) {
        figcaption.each(function () {
            var figitem = $(this);
            var figtext = figitem[0].outerText;
            figitem.parent().find('a').attr('data-caption', figtext)
        });
    }
    $this.find('a').attr('data-fancybox', galleryId);
});

$('.hamburger').on('click', function(){
    $(this).toggleClass('is-active');
    $('#menu-menu-glowne').toggleClass('showMenu');

});


var mySwiper = new Swiper ('.swiper-container', {  
    direction: 'horizontal',
    loop: true,
    effect:'fade',
    speed:2000, 
    autoplay: {
        delay: 2000,
        disableOnInteraction:false, 
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
  });

const dropdownMenu = document.querySelector('.sub-menu');
const menuItemChildren = document.querySelectorAll('.menu-item-has-children');

function toggleCollapse() {
        if (window.innerWidth < 1366) {
            $(menuItemChildren).each(function (index, el) {
                el = $(this);
                el.click(function (e) {
                    e.stopPropagation();
                    el.children(dropdownMenu).eq(1).slideToggle("fast");
                });
            });
        }
    }
    toggleCollapse();

var toTopButton = $('#toTop');
$(window).scroll(function() {
    if ($(window).scrollTop() > 200) {
    toTopButton.addClass('show');
    } else {
    toTopButton.removeClass('show');
    }
});
toTopButton.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '200');
    });